const shop = require('../../shop/views/shop.view.html').trim(),
    centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('root', {
            url: '',
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata(null, false, null, 'Home');
                    },
                ],
            },
            views: {
                '@': {
                    template: shop,
                },
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'center-panel@root': {
                    template: '<wow-rr-carousel placement-id="home_page.carousel" support-compact="false"></wow-rr-carousel>',
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-home-instrumentation page-group="Homepage" placement-ids="home_page.carousel"></wow-rr-home-instrumentation>',
                },
                'notification-panel@root': {
                    template: '<wow-notification-panel></wow-notification-panel>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/root.js